import React, { useState, useEffect } from "react";
import { ILotHeadInfo } from "./LotPage";
import PopupBuyNow from "./PopupBuyNow";
import { ILotModel, TradeStates, PaymentLotStatus, DocumentTypes } from "../../Common/types";
import DepositLot from "./DepositLot";
import { ApplicationDetails } from "../../TradeApplication/components/ApplicationDetails";
//import ListPicturesLoader from "../../Common/ListPicturesLoader/ListPicturesLoader";
import FileUploader from "../FileUploader/FileUploader";
import Fetcher from "../Fetch";
import PopupLoadPictures from "./../../Common/PopupLoadPictures/PopupLoadPictures";
import { useSignal, useSlot } from "react-signal-slot";

import PictureCropPopup from "../../Popups/PictureCropPopup";


interface IPropsType {
    lotHeadInfo: ILotHeadInfo,
    lotId: number,
    lotDetails: ILotModel,
    theme: string,
    isCanMakeBet: boolean
}

function LotActionMenu(props: IPropsType) {

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenCrop, setIsOpenCrop] = useState(false);

    const [lotDetails, setLotDetails] = useState<ILotModel>(props.lotDetails);

    const [isTradeEnd, setIsTradeEnd] = useState<boolean | null>(null);

    const [formattedDate, setFormattedDate] = useState<string>('');

    const [failedTradeReason, setFailedTradeReason] = useState<string | null>();

    const [isLoadedDeposit, setIsLoadedDeposit] = useState(false);
    const [isConfirmedDeposit, setIsConfirmedDeposit] = useState(false);

   
    //Получение данных файла
    const sendFile = async (file) => {
        console.log(file);
        if (file) {
            const formData = new FormData();
            formData.append("Comment", `Документ об оплате задатка для лота ${props.lotId}`);
            formData.append("Title", `Документ об оплате задатка для лота ${props.lotId}`);
            formData.append("DocumentFile", file);
            formData.append("DocumentType", Number(DocumentTypes.PaymentDocument).toString());
            formData.append("LotId", lotDetails.Id.toString());
            formData.append("FileExtension", ".png,.jpg,.jpeg");

            try {
                const response = await Fetcher("/DocumentApi/AddDocument?isChecksFolder=true", {
                    method: "POST",
                    body: formData
                });

                if (response.ok) {
                    const data = await response.json();
                    await getDepositState();

                    console.log("Результат загрузки документа", data);
                }
                else {
                    console.error("Статус не ok", response.statusText);
                }
            } catch (error) {
                console.error("Ошибка", error);
            }
        }
    };

    const getDepositState = async () => {
        try {
            const response = await Fetcher(`/TradeLotApi/GetDepositState?lotId=${lotDetails.Id}`, {
                method: "GET"
            });

            if (response.ok) {
                const data = await response.json();
                setIsLoadedDeposit(data.UpdatedItem.isLoadedDeposit);
                setIsConfirmedDeposit(data.UpdatedItem.isConfirmedDeposit);

                console.log("Результат проверки состояния задатков", data);
            }
            else {
                console.error("Статус не ok", response.statusText);
            }
        } catch (error) {
            console.error("Ошибка", error);
        }
    }

    useEffect(() => {
        getDepositState();
    }, [])

    useEffect(() => {
        const date = new Date(props.lotHeadInfo.LotTradePeriodEnd);

        const time = date.toLocaleTimeString('ru-RU', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });

        const dateString = date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'long',
            weekday: 'short'
        });

        const formatted = `${time} (${dateString})`;
        setFormattedDate(formatted);


        const dateNow = new Date();
        if (date < dateNow) {
            setIsTradeEnd(true);
        } else {
            setIsTradeEnd(false);
        }

    }, [props.lotHeadInfo])

    const closeDepositPopup = () => {
        setIsOpen(false);
    }

    const getFailedTradeReason = async () => {
        try {
            const response = await Fetcher(`/TradeLotApi/GetFailedTradeReason?reason=${lotDetails.FailedTradeReason}`, {
                method: "GET"
            });

            if (response.ok) {
                const data = await response.json();
                setFailedTradeReason(data.UpdatedItem);
            } else {
                console.error("Исключение", response.statusText);
            }
        } catch (error) {
            console.error("Ошибка", error);
        }
    };

    useEffect(() => {
        getFailedTradeReason();
    }, []);

    console.log("Результат проверки на показ кнопок действия с лотом покупателя", !lotDetails.IsUserRoleAdmin &&
        lotDetails.LotTradeStateId == TradeStates.Trading &&
        !lotDetails.listPayments.some((obj) => obj.StatusId === PaymentLotStatus.PaidComission) &&
        lotDetails.CanMakeBet);

    console.log("Результат проверки данных о депозите", lotDetails.DepositIsRequired && !lotDetails.IsDepositWrittenOff);

    console.log("Роль: пользователь - ", !lotDetails.IsUserRoleAdmin);
    console.log("Идёт торг - ", lotDetails.LotTradeStateId == TradeStates.Trading);
    console.log("Комиссия за лот никем не оплачена - ", !lotDetails.listPayments.some((obj) => obj.StatusId === PaymentLotStatus.PaidComission));
    console.log("Пользователь может сделать ставку - ", lotDetails.CanMakeBet);
    console.log("Пользователь не организатор - ", !lotDetails.IsOrganizer);

    console.log("Задаток обязателен - ", lotDetails.DepositIsRequired);
    console.log("Задаток не списан - ", !lotDetails.IsDepositWrittenOff);

    console.log("Список оплат", lotDetails.listPayments);
    console.log("AllowApply", lotDetails.AllowApply);


    return (
        <div className="lotActionMenu">
            <div className="title">
                <h4>{props.lotHeadInfo.Price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽</h4>
                <span>Текущая цена</span>
            </div>
            {(() => {
                if (
                    !lotDetails.IsUserRoleAdmin &&
                    !lotDetails.IsOrganizer &&
                    lotDetails.LotTradeStateId === TradeStates.Trading &&
                    !lotDetails.listPayments.some((obj) => obj.StatusId === PaymentLotStatus.PaidComission) &&
                    lotDetails.CanMakeBet
                ) {
                    if (lotDetails.DepositIsRequired) {
                        if (!isLoadedDeposit && !isConfirmedDeposit) {
                            return <div className="infoItem">Вы не можете участвовать в торге, так как не приложили чек об оплате задатка</div>
                        } else if (isLoadedDeposit && !isConfirmedDeposit) {
                            return <div className="infoItem">Вы не можете участвовать в торге, так как ваш задаток не принят</div>
                        } else {
                            if (props.isCanMakeBet)
                                return (
                                    <button className="defaultPinkButton" onClick={() => { setIsOpen(true) }}>Сделать ставку</button>
                                );
                            else
                                return (
                                    <div className="infoItem">Вы уже сделали ставку. Ваша ставка максимальная. В следующий раз можно будет сделать ставку когда ваша ставка будет перебита другим участником.</div>
                                );
                        }
                    } else {
                        if (props.isCanMakeBet)
                            return (
                                <button className="defaultPinkButton" onClick={() => { setIsOpen(true) }}>Сделать ставку</button>
                            );
                        else
                            return (
                                <div className="infoItem">Вы уже сделали ставку. Ваша ставка максимальная. В следующий раз можно будет сделать ставку когда ваша ставка будет перебита другим участником.</div>
                            );
                    }
                } else {
                    console.log("НЕ ИДЁТ ТОРГ!");
                    if (lotDetails.IsOrganizer || lotDetails.IsUserRoleAdmin) {
                        return null;
                    } else if (lotDetails.DepositIsRequired &&
                        (lotDetails.LotTradeStateId == TradeStates.Approved ||
                        lotDetails.LotTradeStateId == TradeStates.WaitingForStartAllowAcceptance ||
                        lotDetails.LotTradeStateId == TradeStates.WaitingForTrade ||
                        lotDetails.LotTradeStateId == TradeStates.AllowAcceptance)) {
                        console.log("ЗАДАТОК ОБЯЗАТЕЛЕН!");
                        if (!isLoadedDeposit && !isConfirmedDeposit) {
                            console.log("ЗАДАТОК НЕ ОПЛАЧЕН И НЕ ПРИНЯТ!");
                            return <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <button className="defaultPinkButton" onClick={() => { setIsOpen(true) }}>Внести задаток</button>
                                <button onClick={() => {
                                    openPopup("openPopup1", true);
                                    setTitle("setTitle1", "Документ о подтверждении задатка");
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 15 19" fill="none">
                                        <g clip-path="url(#clip0_3590_15630)">
                                            <path d="M1 3.4C1 2.55992 1 2.13988 1.16349 1.81901C1.3073 1.53677 1.53677 1.3073 1.81901 1.16349C2.13988 1 2.55992 1 3.4 1H8.00589C8.37277 1 8.55622 1 8.72885 1.04145C8.8819 1.07819 9.02822 1.1388 9.16243 1.22104C9.3138 1.3138 9.44352 1.44352 9.70294 1.70294L13.2971 5.29706C13.5565 5.55648 13.6862 5.6862 13.779 5.83757C13.8612 5.97178 13.9218 6.1181 13.9586 6.27115C14 6.44378 14 6.62723 14 6.99411V15.6C14 16.4401 14 16.8601 13.8365 17.181C13.6927 17.4632 13.4632 17.6927 13.181 17.8365C12.8601 18 12.4401 18 11.6 18H3.4C2.55992 18 2.13988 18 1.81901 17.8365C1.53677 17.6927 1.3073 17.4632 1.16349 17.181C1 16.8601 1 16.4401 1 15.6V3.4Z" stroke="#170021" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 2C2.67157 2 2 2.67157 2 3.5V15.5C2 16.3284 2.67157 17 3.5 17H11.5C12.3284 17 13 16.3284 13 15.5V7.01476C13 6.62781 12.8505 6.25583 12.5826 5.97654L9.21207 2.46178C8.92917 2.16678 8.53815 2 8.12943 2H3.5ZM4 9.5C3.72386 9.5 3.5 9.72386 3.5 10C3.5 10.2761 3.72386 10.5 4 10.5H11C11.2761 10.5 11.5 10.2761 11.5 10C11.5 9.72386 11.2761 9.5 11 9.5H4ZM4 12.5C3.72386 12.5 3.5 12.7239 3.5 13C3.5 13.2761 3.72386 13.5 4 13.5H8C8.27614 13.5 8.5 13.2761 8.5 13C8.5 12.7239 8.27614 12.5 8 12.5H4Z" fill="url(#paint0_linear_3590_15630)" />
                                        </g>
                                        <defs>
                                            <linearGradient id="paint0_linear_3590_15630" x1="-3.71154" y1="2" x2="14.6544" y2="12.1942" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#0F0098" />
                                                <stop offset="0.629534" stop-color="#B200FF" />
                                                <stop offset="1" stop-color="#FF00F5" />
                                            </linearGradient>
                                            <clipPath id="clip0_3590_15630">
                                                <rect width="40" height="50" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </span>
                        } else if (isLoadedDeposit && !isConfirmedDeposit) {
                            return <div className="infoItem">Ваш задаток принят и ожидает подтверждения</div>
                        } else {
                            if (lotDetails.LotTradeStateId == TradeStates.WaitingForTrade) {
                                return (
                                    <div className="infoItem">Вы допущены до участия в торгах.Когда торг начнётся, вы сможете сделать ставку</div>
                                );
                            } else if (lotDetails.LotTradeStateId == TradeStates.WaitingForStartAllowAcceptance) {
                                return (
                                    <div className="infoItem">Вы допущены к подаче заявок. Когда начнётся приём заявок, вы сможете подать заявку</div>
                                );
                            }
                        }
                    }
                }
            })()}

            {
                lotDetails.AllowApply &&
                <ApplicationDetails lotId={lotDetails.Id} loadApp={true} tradeTypeId={lotDetails.TradeTypeId}></ApplicationDetails>
            }

            {/*{lotDetails.TradeStateId == TradeStates.Trading ||*/}
            {/*    lotDetails.TradeStateId == TradeStates.AllowAcceptance &&*/}
            {/*    !lotDetails.WithoutLegalForce &&*/}
            {/*        <button className="defaultPinkButton" onClick={() => { setIsOpen(true) }}>Внести задаток</button>*/}
            {/*}*/}

            {/*{lotDetails.CanMakeBet && */}
            {/*    <button className="defaultPinkButton" onClick={() => { setIsOpen(true) }}>Сделать ставку</button>*/}
            {/*}*/}

            

            <div className="shortInfo">
                <div className="infoItem">
                    <span>Статус:</span>
                    <h5>{props.lotHeadInfo?.LotState}</h5>
                </div>

                {(lotDetails.LotTradeStateId == TradeStates.TradeAbandoned && lotDetails.FailedTradeReason) && <div className="infoItem">
                    <span>Причина несостоявшихся торгов:</span>
                    {failedTradeReason && <h5>{failedTradeReason}</h5>}
                </div>}

                <div className="infoItem">
                    <span>Сделано ставок:</span>
                    <h5>{props.lotHeadInfo?.CountBets}</h5>
                </div>

                <div className="infoItem">
                    <span>Вид торгов:</span>
                    <h5>{props.lotHeadInfo?.TradeType}</h5>
                </div>

                {props.lotDetails.DepositIsRequired &&
                    <div className="infoItem">
                        <span>Размер задатка:</span>
                        <h5>{props.lotDetails.DepositSize
                            ? `${props.lotDetails.DepositSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽`
                            : 'Сумма не найдена, обратитесь в тех.поддержку'}</h5>
                        {/*<button>*/}
                        {/*    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">*/}
                        {/*        <g clip-path="url(#clip0_2143_7419)">*/}
                        {/*            <path d="M7.08333 3.33333H5.41667C4.26833 3.33333 3.33333 4.26833 3.33333 5.41667V7.08333C3.33333 8.23167 4.26833 9.16667 5.41667 9.16667H7.08333C8.23167 9.16667 9.16667 8.23167 9.16667 7.08333V5.41667C9.16667 4.26833 8.23167 3.33333 7.08333 3.33333ZM7.5 7.08333C7.5 7.31333 7.31333 7.5 7.08333 7.5H5.41667C5.18667 7.5 5 7.31333 5 7.08333V5.41667C5 5.18667 5.18667 5 5.41667 5H7.08333C7.31333 5 7.5 5.18667 7.5 5.41667V7.08333ZM12.9167 9.16667H14.5833C15.7317 9.16667 16.6667 8.23167 16.6667 7.08333V5.41667C16.6667 4.26833 15.7317 3.33333 14.5833 3.33333H12.9167C11.7683 3.33333 10.8333 4.26833 10.8333 5.41667V7.08333C10.8333 8.23167 11.7683 9.16667 12.9167 9.16667ZM12.5 5.41667C12.5 5.18667 12.6867 5 12.9167 5H14.5833C14.8133 5 15 5.18667 15 5.41667V7.08333C15 7.31333 14.8133 7.5 14.5833 7.5H12.9167C12.6867 7.5 12.5 7.31333 12.5 7.08333V5.41667ZM7.08333 10.8333H5.41667C4.26833 10.8333 3.33333 11.7683 3.33333 12.9167V14.5833C3.33333 15.7317 4.26833 16.6667 5.41667 16.6667H7.08333C8.23167 16.6667 9.16667 15.7317 9.16667 14.5833V12.9167C9.16667 11.7683 8.23167 10.8333 7.08333 10.8333ZM7.5 14.5833C7.5 14.8133 7.31333 15 7.08333 15H5.41667C5.18667 15 5 14.8133 5 14.5833V12.9167C5 12.6867 5.18667 12.5 5.41667 12.5H7.08333C7.31333 12.5 7.5 12.6867 7.5 12.9167V14.5833ZM6.66667 19.1667C6.66667 19.6267 6.29333 20 5.83333 20H4.16667C1.86917 20 0 18.1308 0 15.8333V14.1667C0 13.7067 0.373333 13.3333 0.833333 13.3333C1.29333 13.3333 1.66667 13.7067 1.66667 14.1667V15.8333C1.66667 17.2117 2.78833 18.3333 4.16667 18.3333H5.83333C6.29333 18.3333 6.66667 18.7067 6.66667 19.1667ZM20 14.1667V15.8333C20 18.1308 18.1308 20 15.8333 20H14.1667C13.7067 20 13.3333 19.6267 13.3333 19.1667C13.3333 18.7067 13.7067 18.3333 14.1667 18.3333H15.8333C17.2117 18.3333 18.3333 17.2117 18.3333 15.8333V14.1667C18.3333 13.7067 18.7067 13.3333 19.1667 13.3333C19.6267 13.3333 20 13.7067 20 14.1667ZM20 4.16667V5.83333C20 6.29333 19.6267 6.66667 19.1667 6.66667C18.7067 6.66667 18.3333 6.29333 18.3333 5.83333V4.16667C18.3333 2.78833 17.2117 1.66667 15.8333 1.66667H14.1667C13.7067 1.66667 13.3333 1.29333 13.3333 0.833333C13.3333 0.373333 13.7067 0 14.1667 0H15.8333C18.1308 0 20 1.86917 20 4.16667ZM0 5.83333V4.16667C0 1.86917 1.86917 0 4.16667 0H5.83333C6.29333 0 6.66667 0.373333 6.66667 0.833333C6.66667 1.29333 6.29333 1.66667 5.83333 1.66667H4.16667C2.78833 1.66667 1.66667 2.78833 1.66667 4.16667V5.83333C1.66667 6.29333 1.29333 6.66667 0.833333 6.66667C0.373333 6.66667 0 6.29333 0 5.83333ZM13.3333 15.4167C13.3333 16.1067 12.7733 16.6667 12.0833 16.6667C11.3933 16.6667 10.8333 16.1067 10.8333 15.4167C10.8333 14.7267 11.3933 14.1667 12.0833 14.1667C12.7733 14.1667 13.3333 14.7267 13.3333 15.4167ZM15.4167 10.8333C16.1067 10.8333 16.6667 11.3933 16.6667 12.0833C16.6667 12.7733 16.1067 13.3333 15.4167 13.3333C14.7267 13.3333 14.1667 12.7733 14.1667 12.0833C14.1667 11.3933 14.7267 10.8333 15.4167 10.8333ZM10.8333 12.0833C10.8333 11.3933 11.3933 10.8333 12.0833 10.8333C12.7733 10.8333 13.3333 11.3933 13.3333 12.0833C13.3333 12.7733 12.7733 13.3333 12.0833 13.3333C11.3933 13.3333 10.8333 12.7733 10.8333 12.0833Z" fill="#B200FF" />*/}
                        {/*        </g>*/}
                        {/*        <defs>*/}
                        {/*            <clipPath id="clip0_2143_7419">*/}
                        {/*                <rect width="20" height="20" fill="white" />*/}
                        {/*            </clipPath>*/}
                        {/*        </defs>*/}
                        {/*    </svg>*/}
                        {/*</button>*/}
                    </div>
                }

                {lotDetails.StepPercent && lotDetails.BasePrice &&
                    <div className="infoItem">Размер шага: {lotDetails.StepPercent}% от начальной суммы
                        ({(Number(lotDetails.BasePrice) * Number((lotDetails.StepPercent / 100).toFixed(2))).toLocaleString("ru-RU")}₽)</div>}
                {lotDetails.StepValue && lotDetails.BasePrice &&
                    <div className="infoItem">Размер шага: {Number(Number(lotDetails.StepValue).toFixed(2)).toLocaleString("ru-RU")}₽</div>}

                {(lotDetails.WithoutApplicationsAcceptance ||
                    lotDetails.TradeStateId == TradeStates.Traded ||
                    lotDetails.TradeStateId == TradeStates.TradeAbandoned) &&
                    <div className="infoItem">
                        <span>До окончания торгов:</span>
                        <h5>{formattedDate}</h5>
                    </div>}
            </div>

            {/*(Model.LotPriceHistoryModel.Count > 0 && Model.LotPriceHistoryModel.OrderByDescending(x => x.Price).First().BettorId == Model.CurrentCompanyId*/}
            {/*&& (Model.TradeStateId == (int)TradeStates.Traded || Model.TradeStateId == (int)TradeStates.Completed))*/}

            {/*{props.lotDetails.LotPriceHistory.Count > 0 &&*/}
            {/*    props.lotDetails.LotPriceHistory    */}
            {/*}*/}

            {!props.lotDetails.IsOrganizer
                && props.lotDetails.BuyNowPrice
                && props.lotDetails.TradeStateId != TradeStates.Completed
                && props.lotDetails.TradeStateId != TradeStates.ApplicationProcessing
                && !lotDetails.IsUserRoleAdmin &&
                <PopupBuyNow lotId={props.lotId} isTradeEnd={false} shippingMethodId={lotDetails.ShippingMethodId} BuyNowPrice={props.lotDetails.BuyNowPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} mithraTheme={props.theme} />
            }


            {isOpen &&
                <DepositLot isOpen={isOpen}
                    close={closeDepositPopup}
                    theme={props.theme}
                    lotDetails={props.lotDetails}
                    lotId={props.lotId}
                    isLoadedDeposit={isLoadedDeposit}
                    isConfirmedDeposit={isConfirmedDeposit} />
            }



            <PictureCropPopup
                isOpen={isOpenCrop}
                close={() => setIsOpenCrop(false)}
                head={{ title: "Загрузите чек" }}
                maxSize={2}
                getPicture={(picture) => sendFile(picture)}
            />
            {/*<PopupLoadPictures*/}
            {/*    signalOpenPopup1={"openPopup1"}*/}
            {/*    signalSendFile1={"sendFile1"}*/}
            {/*    signalSetTitle1={"setTitle1"}*/}
            {/*/>*/}

        </div>
    )
}


export default LotActionMenu;